export const getMsalConfig = () => {
  // Always use HTTPS for production
  const redirectUri = window.location.hostname === 'localhost'
    ? window.location.origin
    : 'https://calendar.cloudappi.net';

  return {
    auth: {
      clientId: 'bd89f634-98da-4b71-845b-4b73d64b69d2',
      authority: 'https://login.microsoftonline.com/64e9e716-2e03-4ad5-b0e3-389d0276d18a',
      redirectUri: redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    }
  };
};

// For backwards compatibility
export const msalConfig = getMsalConfig();

export const loginRequest = {
  scopes: ['User.Read']
};
